import { render, staticRenderFns } from "./UpdateIndex.vue?vue&type=template&id=63f45814"
import script from "./UpdateIndex.vue?vue&type=script&lang=js"
export * from "./UpdateIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports